import { render, staticRenderFns } from "./VideoCatelogueManage.vue?vue&type=template&id=5eb2e3fc&scoped=true"
import script from "./VideoCatelogueManage.vue?vue&type=script&lang=js"
export * from "./VideoCatelogueManage.vue?vue&type=script&lang=js"
import style0 from "./VideoCatelogueManage.vue?vue&type=style&index=0&id=5eb2e3fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb2e3fc",
  null
  
)

export default component.exports